import { Component } from '@angular/core';

@Component({
  selector: 'stars-app-guest-partners',
  templateUrl: './guest-partners.component.html',
  styleUrls: ['./guest-partners.component.scss']
})
export class GuestPartnersComponent {}
